import React from "react";
import { ExpandableSportCategoryMenuItem } from "../ExpandableSportCategoryMenuItem.js";
import { MenuItem } from "../MenuItem.js";
import PropTypes from "prop-types";
import { TrackingInfo } from "../../tracking/TrackingInfoMenu.js";

const MenuItemList = props => {
  const { items, component, termKeyPrefix, onClick } = props;

  const getDataTestId = (termKey, termKeyPrefix) => {
    if (termKey?.startsWith(termKeyPrefix)) {
      return termKey;
    }
    return [termKeyPrefix, termKey].filter(elem => !!elem).join("-");
  };

  return (
    <ul className={"menu-item-list"}>
      {items.map(childItem => {
        const hasChildren = childItem.items?.length > 0;
        const Component = hasChildren
          ? ExpandableSportCategoryMenuItem
          : component || MenuItem;

        const dataTestId = getDataTestId(childItem.termKey, termKeyPrefix);
        return (
          <Component
            key={`menu-item-${dataTestId}`}
            dataTestId={dataTestId}
            item={childItem}
            trackingInfo={TrackingInfo}
            onClick={onClick}
            isChildItem={!hasChildren}
          />
        );
      })}
    </ul>
  );
};

MenuItemList.propTypes = {
  items: PropTypes.array,
  component: PropTypes.func,
  termKeyPrefix: PropTypes.string,
  onClick: PropTypes.func
};

export default MenuItemList;
